import { render, staticRenderFns } from "./ZapisSpecialistsCardsList.vue?vue&type=template&id=e1bdfb0e&scoped=true&"
import script from "./ZapisSpecialistsCardsList.vue?vue&type=script&lang=js&"
export * from "./ZapisSpecialistsCardsList.vue?vue&type=script&lang=js&"
import style0 from "./ZapisSpecialistsCardsList.vue?vue&type=style&index=0&id=e1bdfb0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bdfb0e",
  null
  
)

export default component.exports